import { Spinner } from 'react-bootstrap';
import styled from 'styled-components';

export const Loading = styled(Spinner)`
      font-size: 10px;
      height: 20px;
      width: 20px;
`;
